<template>
  <div class="login-step">
    <label v-if="stepLabel" class="step-label">{{stepLabel}}</label>
    <slot name="input"></slot>
    <div class="button" @click="$emit('submit')">enter</div>
    <slot name="verbiage"></slot>
    <div class="alt-link">{{linkLabel}}</div>
    <div class="link" v-if="!hasBeenSent" @click="$emit('linkClicked')">{{linkText}}</div>
    <div v-if="hasBeenSent">thank you for your request. you should receive your temporary PIN within a few minutes</div>
    <slot name="graphics"></slot>
  </div>
</template>

<script>
  export default {
    props: {
      hasBeenSent: {
        type: Boolean,
        default: false,
      },
      inputLabel: String,
      linkLabel: String,
      linkText: String,
      stepLabel: String,
    },

    name: 'LoginStep'
  }
</script>

<style lang="sass">
.login-step
  .step-label
    display: block
    margin: 1.5rem auto 1rem auto

  .button
    margin-top: 2rem

  .alt-link
    margin: 3rem auto .5rem auto
    
  .link
    margin: .5rem auto
</style>
